import React from "react";
import ChangePasswordForm from "../../forms/account/ChangePassworForm";

const ChangePasswordView = ({ onSubmit = () => {}, initialValues }) => {
  return (
    <ChangePasswordForm onSubmit={onSubmit} initialValues={initialValues} />
  );
};

export default ChangePasswordView;
